import React from 'react';
import { Box, Button, Card, Icons, Stack, Switch, Typography } from '@curves/ui-base';
import { Overview } from '@curves/ui-shared';

import { usePointsContext } from '@Local/Points/Components/PointsContext';
import usePointsRedeemItemApi from '@Apis/usePointsRedeemItemApi';
import { PointsProductGiftTableMoreLabel } from '@Local/Points/ProductGift/';
const headerRow = [
    {
        cellKey: 'imageSrc',
        headerLabel: '贈品',
        align: 'left',
        isFixed: true,
        isFixedLeft: true,
        style: { minWidth: 50, left: 0 },
        formatCell: (value, rowData, { onClick }) => {
            return (
                <Stack alignItems="center" spacing={1}>
                    <Box className="product-gift-img-label">
                        <img src={value} alt={rowData.itemName} />
                    </Box>
                    <Typography variant="h6" className="font-weight-bold">
                        {rowData.itemName}
                    </Typography>
                    <Icons.QuestionCircle
                        className="cursor-pointer"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onClick(rowData);
                        }}
                    />
                </Stack>
            );
        },
    },
    {
        cellKey: 'points',
        headerLabel: '兌換點數',
        align: 'center',
        width: 8,
        style: { minWidth: 50 },
        formatCell: (value) => {
            return <Typography variant="h5" component="span">{`${value}點`}</Typography>;
        },
    },
    {
        cellKey: 'originalPrice',
        headerLabel: '成本價',
        align: 'center',
        width: 8,
        style: { minWidth: 50 },
        formatCell: (value) => {
            return (
                <Typography component="span">
                    {value}
                </Typography>
            );
        },
    },
    {
        cellKey: 'costPrice',
        headerLabel: '市價',
        align: 'center',
        width: 8,
        style: { minWidth: 50 },
        formatCell: (value) => {
            return (
                <Typography component="span">
                    {value}
                </Typography>
            );
        },
    },
    {
        cellKey: 'currentStock',
        headerLabel: '庫存量',
        align: 'center',
        width: 8,
        style: { minWidth: 50 },
        formatCell: (value) => {
            return (
                <Typography variant="h5" component="span">
                    {value}
                </Typography>
            );
        },
    },
    {
        cellKey: 'isEnabled',
        headerLabel: '上架',
        align: 'center',
        width: 3,
        style: { minWidth: 50 },
        formatCell: (value, rowData, { onSwitchChange }) => {
            return (
                <Switch
                    onChange={(_e, checked) => {
                        onSwitchChange(rowData, { isEnabled: checked });
                    }}
                    defaultChecked={value}
                />
            );
        },
    },
    {
        cellKey: 'more',
        headerLabel: '',
        align: 'center',
        width: 3,
        style: { minWidth: 50 },
        formatCell: (_value, rowData, { onMoreLabelClick }) => {
            return <PointsProductGiftTableMoreLabel rowData={rowData} onClick={onMoreLabelClick} />;
        },
    },
];
const PointsProductGiftTable = (props) => {
    const { dialogRef, sourceData, pageModel, setNextPage, refresh } = usePointsContext();
    const { putPointsProductGiftItemDataApi } = usePointsRedeemItemApi();
    const handleAddProductGiftOnClick = () => {
        dialogRef.current.openProductGiftItemDialog({}, refresh);
    };
    const handleRowOnClick = (rowData) => {
        dialogRef.current.openProductGiftRecordDialog(rowData, refresh);
    };
    const handleProdcutsInfoOnClick = (rowData) => {
        dialogRef.current.openPointsProductGuideDialog(rowData);
    };
    const handleMoreLabelOnClick = (type, rowData) => {
        if (type === 'editProductGift') {
            dialogRef.current.openProductGiftItemDialog(rowData, refresh);
        } else if (type === 'editProductGiftStock') {
            dialogRef.current.openProductGiftItemInventory(rowData, refresh);
        }
    };
    const handleSwitchChange = (sourceData, changeData) => {
        const { itemID } = sourceData;
        let params = JSON.parse(JSON.stringify(sourceData));
        Object.assign(params, { ...changeData });
        doPutSwitchChangeApi(params, itemID);
    };
    // 換頁：先 blur 焦點避免影響捲動，再更新頁碼
    const handlePageOnChange = (num) => {
        if (document.activeElement) document.activeElement.blur();
        setNextPage(num);
    };
    const doPutSwitchChangeApi = async (params, itemID) => {
        const resp = await putPointsProductGiftItemDataApi(params, itemID);
        resp && refresh();
    };
    // 組出 Overview 所需的資料與換頁函式
    const contextValue = {
        overviewData: {
            list: sourceData,
            pagination: {
                pageIndex: pageModel.pageIndex,
                pageSize: pageModel.pageSize,
                totalCount: pageModel.totalCount,
                totalPage: pageModel.totalPage ?? 0,
            },
        },
        updateOverviewPage: handlePageOnChange,
    };
    return (
        <Card className="mt-4">
            <Card.CardContent className="p-3">
                <Stack spacing={2}>
                    <Button variant="contained" color="info" onClick={handleAddProductGiftOnClick}>
                        新增贈品
                    </Button>
                </Stack>
                <Overview contextValue={contextValue} idKey="itemID">
                    <Stack className="overview__toolbar" alignItems="center" justifyContent="end">
                        <Overview.TotalCount showRange />
                    </Stack>
                    <Overview.Table
                        headerRow={headerRow}
                        cardProps={{ className: 'theme-gray' }}
                        cellWidth={12}
                        isFixed
                        rowOnClick={handleRowOnClick}
                        cellRenderContext={{ onClick: handleProdcutsInfoOnClick, onMoreLabelClick: handleMoreLabelOnClick, onSwitchChange: handleSwitchChange }}
                    />
                    <Overview.Pagination className="mt-4" />
                </Overview>
            </Card.CardContent>
        </Card>
    );
};
export default PointsProductGiftTable;
